import React, { forwardRef } from 'react';

const AttributesAsJSONIcon = forwardRef((props, ref) => {
  const {
    style: { color },
    ...otherProps
  } = props;

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={12}
      height={12}
      viewBox="0 0 12 12"
      fill="none"
      {...otherProps}
    >
      <path
        d="M11 0H1.00005C0.45015 0 0 0.45015 0 1.00005V11C0 11.5499 0.45015 12 1.00005 12H11C11.5499 12 12 11.5499 12 11V1.00005C12 0.45015 11.5499 0 11 0ZM4.20705 7.293L3.49995 7.99995L1.5 6L3.50055 4.00005L4.2075 4.707L2.91405 6L4.20705 7.293ZM5.31195 10.5L4.34625 10.2411L6.68805 1.5L7.65375 1.7589L5.31195 10.5ZM8.49945 7.99995L7.7925 7.293L9.08595 6L7.79295 4.707L8.50005 4.00005L10.5 6L8.49945 7.99995Z"
        fill={color}
      />
    </svg>
  );
});

AttributesAsJSONIcon.defaultProps = {
  style: {
    color: 'black',
  },
};

export default AttributesAsJSONIcon;
